module.exports = __webpack_public_path__ + "img/one.a31e890b.png";